import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'Bot',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'botId',
        'botName',
        'botUrl',
        'botEmail',
        'botPassword',
        'botKbn',
        'service',
        // 'settingButton',
        'modifyButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          botId: 'BotID',
          botName: 'Bot名',
          botUrl: 'Webhook URL',
          botEmail: 'メールアドレス',
          botPassword: 'パスワード',
          botKbn: 'Bot種別',
          service: 'サービス名',
          settingButton: '',
          modifyButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          botId: 'wp-5',
          botName: '',
          botUrl: '',
          botEmail: '',
          botPassword: '',
          botKbn: '',
          service: '',
          settingButton: 'wp-5 has-button',
          modifyButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'botId',
          'botName',
          'botUrl',
          'botEmail',
          'botPassword',
          'botKbn',
          'service'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更・削除
      modifyTargetId: null,
      deleteTargetId: null
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.bot.categoryName,

      // model
      botModel: state => state.bot.botModel,
      serviceModel: state => state.bot.serviceModel,

      // form
      values: state => state.bot.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'bot/isRegister',
      isModify: 'bot/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.botModel, 'botUuid', this.modifyTargetId, 'botId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    botKbnList() {
      return Constants.Bot.BotKbn
    },
    serviceList () {
      let list = []
      this.serviceModel.forEach(item => list.push({
        value: item.serviceUuid,
        label: item.serviceName
      }))
      return list
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpBotName: {
      get () {
        return this.values.inpBotName
      },
      set (value) {
        this.setInputValue({
          key: 'inpBotName',
          value: value
        })
      }
    },
    inpBotUrl: {
      get () {
        return this.values.inpBotUrl
      },
      set (value) {
        this.setInputValue({
          key: 'inpBotUrl',
          value: value
        })
      }
    },
    inpMailAddress: {
      get () {
        return this.values.inpMailAddress
      },
      set (value) {
        this.setInputValue({
          key: 'inpMailAddress',
          value: value
        })
      }
    },
    inpPassword: {
      get () {
        return this.values.inpPassword
      },
      set (value) {
        this.setInputValue({
          key: 'inpPassword',
          value: value
        })
      }
    },
    inpBotKbn: {
      get () {
        return this.values.inpBotKbn
      },
      set (value) {
        this.setInputValue({
          key: 'inpBotKbn',
          value: value
        })
      }
    },
    inpServiceId: {
      get () {
        return this.values.inpServiceId
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceId',
          value: value
        })
      }
    },

    // validate
    inpBotNameIsValid () {
      return Validator.validText(this.inpBotName)
    },
    inpBotUrlIsValid () {
      return Validator.validText(this.inpBotUrl)
    },
    inpMailAddressIsValid () {
      return Validator.validText(this.inpMailAddress)
    },
    inpPasswordIsValid () {
      return Validator.validText(this.inpPassword)
    },
    inpBotKbnIsValid () {
      return Validator.validSelect(this.inpBotKbn)
    },
    inpServiceIdIsValid () {
      return Validator.validSelect(this.inpServiceId)
    },
    formIsValid () {
      return this.inpBotNameIsValid &&
        this.inpBotUrlIsValid &&
        this.inpMailAddressIsValid &&
        this.inpPasswordIsValid &&
        this.inpBotKbnIsValid &&
        this.inpServiceIdIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }

      // 削除
      if (this.confirmKey === 'delete') {
        to ?
          this.deleteData() :
          this.deleteTargetId = null
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'bot/loadModel',
      initRegister: 'bot/initRegister',
      initModify: 'bot/initModify',
      showBotDestinationModal: 'botDestinationModal/show'
    }),
    ...mapMutations({
      setInputValue: 'bot/setInputValue',
    }),

    init () {
      this.loading = true

      //TODO
      let botParams = {}
      let serviceParams = {
        filters: {
          serviceStatus: 1
        }
      }

      // データ読出し
      this.loadModel({
        botParams: botParams,
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.botModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.botModel, 'botUuid', this.modifyTargetId, 'botId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true
      // console.log(this.isModify)
      let parameters = {
        request: {
          botName: this.inpBotName,
          botUrl: this.inpBotUrl,
          botEmail: this.inpMailAddress,
          botPassword: this.inpPassword,
          botKbn: this.inpBotKbn,
          serviceUuid: this.inpServiceId
        }
      }
      if (this.isModify) {
        parameters.botUuid = this.values.botUuid
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['bot'],
        [this.isRegister ?
          'v1BotPost' :
          'v1BotPatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.processing = true

      let parameters = {
        botUuid: this.deleteTargetId
      }
      console.log('delete data', parameters)

      // 登録
      ApiManager.request(
        ['bot'],
        ['v1BotDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.showToast({
              title: this.categoryName + 'の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      if (key === 'botKbn')
        return Utility.getConstantsLabel(['Bot', 'BotKbn'], value)
      if (key === 'service')
        return value.serviceName
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.modifyTargetId = null
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.botUuid
      this.initModify({
        data: props.row
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.botUuid
      const id = Utility.getObjectArrayValue(this.botModel, 'botUuid', this.deleteTargetId, 'botId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    },
    showDestinationController (props) {
      this.showBotDestinationModal({
        targetId: props.row.botUuid,
        botNotifyTo: props.row.botNotifyTo
      })
    }
  }
}